import usePrivateAxios from "@/common/api/usePrivateAxios";
import { useMutation } from "@tanstack/react-query";

interface UseReviewLeadProps {
  privateCompanyLeadId?: string
  state?: string
  onSuccess: () => void
  onError: () => void
}

const useReviewLead = ({ privateCompanyLeadId, state, onSuccess, onError }: UseReviewLeadProps) => {
  const privateAxios = usePrivateAxios();
  return useMutation({
    mutationKey: ['reviewLead'],
    mutationFn: async (data?: { description?: string }) => {
      const private_company_lead = {
          last_review_attributes: {
          state,
          description: data?.description
        }
      }

      await privateAxios.putForm(`/funnel/private_company_leads/${privateCompanyLeadId}`, {
        private_company_lead
      })
    },
    onSuccess,
    onError,
  });
}

export default useReviewLead